var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { fontSizes } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import { FAR_MONEY_CHECK_ALT, FAS_EXCLAMATION_CIRCLE } from '../../../const/iconProps';
import { colors } from '../../../defaultTheme';
import { isPayLaterProduct } from '../../../helpers/productTypeHelpers';
import useApiMachine from '../../../hooks/machines/useApiMachine';
import { t } from '../../../strings/i18n';
import { PaymentMethodName, PaymentMethodRemoveButton, PaymentMethodRemovePrompt } from '../../atoms/PaymentMethod';
import { getAccountType } from './helpers';
import PaymentMethodErrorMessageBox from './PaymentMethodErrorMessageBox';
const PaymentMethodsDesktopTable = styled.table `
  width: 100%;
  border-collapse: collapse;
  td {
    color: ${colors.black};
  }
  th {
    white-space: nowrap;
  }
`;
const TableRowTopBottom = styled.tr `
  border-top: 1px solid ${colors.mediumGrey};
`;
const Cell = styled.td `
  .payment-method-remove-button {
    font-size: ${fontSizes.root}px;
  }
`;
const ExpandedColumn = styled.td `
  padding: 0;
`;
const PaymentMethodRemoveButtonWrapper = styled(Inset) `
  display: flex;
  justify-content: flex-end;
`;
const TableRow = ({ paymentMethod, expandedId, errorMessage, handleClosePrompt, handleDeleteButton, handleConfirmDeletePaymentMethod, buttonRefs }) => {
    const [apiMachine] = useApiMachine();
    const { data: accountSummary } = apiMachine.context.accountSummaryQueryResult;
    const productType = accountSummary.product.type;
    const { bankAccountNumberLast4, cardNumberLast4, id: paymentMethodId, name, nickname, paymentMedium, type } = paymentMethod;
    const accountNumber = `(...${bankAccountNumberLast4 || cardNumberLast4})`;
    const accountName = nickname || name;
    const isPayLater = isPayLaterProduct(productType);
    return (_jsxs(_Fragment, { children: [_jsxs(TableRowTopBottom, { children: [_jsx("td", { children: _jsx(Inset, Object.assign({ horizontal: "base", tabIndex: 0, vertical: "large" }, { children: _jsx(PaymentMethodName, { leftIcon: FAR_MONEY_CHECK_ALT, name: accountName }) })) }), _jsx("td", { children: _jsx(Inset, Object.assign({ all: "base", "data-cy": "payment-method-account-type", tabIndex: 0 }, { children: getAccountType(type, paymentMedium) })) }), _jsx("td", { children: _jsx(Inset, Object.assign({ all: "base", "data-cy": "payment-method-account-number", tabIndex: 0 }, { children: accountNumber })) }), !isPayLater && (_jsx(Cell, { children: _jsx(PaymentMethodRemoveButtonWrapper, Object.assign({ right: "small" }, { children: _jsx(PaymentMethodRemoveButton, { accountName: accountName, buttonRefs: buttonRefs, className: "payment-method-remove-button", expandedId: expandedId, paymentMethodId: paymentMethodId, onClick: () => handleDeleteButton(paymentMethodId) }) })) }))] }), expandedId === paymentMethodId && (_jsx("tr", { children: _jsx(ExpandedColumn, Object.assign({ colSpan: 4 }, { children: errorMessage ? (_jsx(Inset, Object.assign({ bottom: "base", left: "large", right: "large", top: "base" }, { children: _jsx(PaymentMethodErrorMessageBox, { errorMessage: errorMessage, handleClose: handleClosePrompt, leftIcon: FAS_EXCLAMATION_CIRCLE }) }))) : (_jsx(PaymentMethodRemovePrompt, { buttonRefs: buttonRefs, handleConfirmDeletePaymentMethod: handleConfirmDeletePaymentMethod, isDesktop: true, leftIcon: FAS_EXCLAMATION_CIRCLE, paymentMethod: paymentMethod, onClose: handleClosePrompt })) })) }))] }));
};
const TableBody = (_a) => {
    var { paymentMethods } = _a, paymentMethodProps = __rest(_a, ["paymentMethods"]);
    return (_jsx("tbody", { children: paymentMethods.map((paymentMethod) => (_jsx(TableRow, Object.assign({ paymentMethod: paymentMethod }, paymentMethodProps), paymentMethod.id))) }));
};
const TableHeader = ({ tableHeader }) => {
    return (_jsx("thead", { children: _jsx("tr", { children: tableHeader.map((header, index) => {
                return (_jsx("th", { children: _jsx(Inset, Object.assign({ "data-cy": "manage-payment-method-header", horizontal: "base", left: index === 0
                            ? 'large'
                            : 'base' }, { children: header })) }, header));
            }) }) }));
};
const PaymentMethodsDesktop = (_a) => {
    var paymentMethodProps = __rest(_a, []);
    const tableHeader = [
        t('addPaymentMethod.name'),
        t('addPaymentMethod.accountType'),
        t('addPaymentMethod.accountNumber'),
        ''
    ];
    return (_jsxs(PaymentMethodsDesktopTable, { children: [_jsx(TableHeader, { tableHeader: tableHeader }), _jsx(TableBody, Object.assign({}, paymentMethodProps))] }));
};
export default PaymentMethodsDesktop;
